import React from 'react'
import { IconCheck } from '@tabler/icons-react'

//@ts-ignore
import { components } from 'react-select'
import { Container } from './styles'

const CustomOptions = (props: any) => {
  const selectedOptions = props.getValue()
  const isSelected = selectedOptions.includes(props.data)

  return (
    <components.Option {...props}>
      <>
        <Container>
          {props.data.label}
          {isSelected && (
            <div>
              <IconCheck size={16} />
            </div>
          )}
        </Container>
        {/* {props.data.description && (
          //@ts-ignore
          <Description isSelected={props.isSelected}>{props.data.description}</Description>
        )} */}
      </>
    </components.Option>
  )
}

export default CustomOptions
